export const NumberDecimal = ({ number, decimal }) => {
  let sum = Number(number).toLocaleString(undefined, {
    minimumFractionDigits: decimal === 0 ? 0 : decimal !== 0 ? decimal : 2,
    maximumFractionDigits: decimal ? decimal : decimal + 4,
  });
  return sum;
};
